import React, { useEffect, useState } from 'react';
import axios from '../../api/axios';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

const NewCategory = () => {
    const { categoryId } = useParams()
    const navigate = useNavigate()
    const [state, setState] = useState({ name: '', description: '' })
    const [errors, setErrors] = useState({});

    const validateForm = () => {
        const newErrors = {};
        if (!state.name) newErrors.name = "name is required";
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    useEffect(() => {
        if (categoryId) {
            axios.get(`/expenses/expense-categories/${categoryId}`).then((res) => {
                setState({...state, name: res.data?.name, description: res.data.description})
                console.log(res.data);
            });
        }
    }, [categoryId])
    const handleSubmit = (e) => {
        e.preventDefault()
        if (!validateForm()) return;

        const payload = {
            name: state.name,
            description: state.description
        }
        const apiUrl = categoryId
            ? `/expenses/expense-categories/${categoryId}`  // Update endpoint
            : '/expenses/expense-categories';           // Create endpoint

        const apiCall = categoryId
            ? axios.put(apiUrl, payload)                   // Use PUT for update
            : axios.post(apiUrl, payload);                 // Use POST for create

        apiCall
            .then(res => {
                if (res.data.success === true) {
                    toast.success(res.data?.message || `Category ${categoryId ? 'updated' : 'created'} successfully!`)
                    const timer = setTimeout(() => {
                        navigate('/category-list')
                    }, 2000);
                    return () => clearTimeout(timer);
                } else {
                    toast.error(res.data?.message || `Category ${categoryId ? 'updated' : 'created'} successfully!`)
                }
            })
            .catch(err => toast.error(err.message || `Error`));
    }
    return (
        <div className="p-4 max-w-6xl mx-auto text-sm bg-white rounded-md">
            <h2 className="text-xl font-bold mb-4">Category — Add/Update</h2>
            <form onSubmit={handleSubmit} className="space-y-4">
                <div className="grid md:grid-cols-2 gap-4 mb-4">
                    <div>
                        <label className="font-semibold text-sm">Category Name</label>
                        <input
                            type="text"
                            value={state?.name}
                            placeholder='Enter name'
                            onChange={(e) => {
                                setState({ ...state, name: e.target.value })
                                if (errors.name) setErrors(prev => ({ ...prev, name: null }))
                            }}
                            className={errors.name ? 'border-red-500 border w-full rounded mt-1' : 'border w-full rounded mt-1'}
                        />
                        {errors.name && <p className="text-red-500 text-xs">{errors.name}</p>}
                    </div>
                    <div>
                        <label className="font-semibold text-sm">Category Description</label>
                        <input
                            type="text"
                            value={state?.description}
                            placeholder='Enter description'
                            onChange={(e) => setState({ ...state, description: e.target.value })}
                            className="border w-full rounded mt-1"
                        />
                    </div>
                </div>
                <div className="flex justify-center items-center gap-4 mt-4">
                    <button type='submit' className=" bg-green-600 hover:bg-green-700 text-white px-8 py-2 rounded">Save</button>
                    <button type="button" onClick={() => navigate('/category-list')} className="bg-gray-400 hover:bg-gray-500 text-white px-8 py-2 rounded">Close</button>
                </div>
            </form>
        </div>
    );
};

export default NewCategory;